module.exports = __webpack_public_path__ + "static/img/03_訪客登記.e3bace5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/03_訪客登記.png
// module id = 93bm
// module chunks = 1